export { PersonalDataScreen } from './PersonalDataScreen';
